import React from 'react';
import Alert from 'components/ui/Alert';
import Panel from 'components/v2/Panel';
import { useTranslation } from 'react-i18next';

export default function FSCNotApplied() {
  const { t } = useTranslation();

  return (
    <Panel>
      <Alert type="warning" title={t('FSC_NOT_APPLIED')}>
        {t('FSC_NOT_APPLIED_DESCRIPTION')}
      </Alert>
    </Panel>
  );
}
